<div class="requests-container">
  <!-- Tabs -->
  <div class="tabs-wrapper">
    <app-tabs
      [tabHeaders]="tabs"
      [(selectedTab)]="selectedTab"
      (selectedTabChange)="onTabChange($event)"
      type="pill"
      size="medium"
      [fitContent]="true"
    ></app-tabs>
  </div>

  <!-- Table -->
  <div class="requests-table">
    <app-table
      [data]="data"
      [columns]="headers"
      [mainField]="mainField"
      [title]="activeStatus === 'PENDING_VERIFICATION' ? ('requestsPage.title.pendingVerification' | transloco) : ('requestsPage.title.pendingPayment' | transloco)"
      [rows]="limit"
      [totalRecords]="totalRecords"
      [isLoading]="isLoading"
      [loadError]="loadError"
      (retryLoad)="loadRequests()"
      (onPageChange)="onPageChange($event)"
      (onSort)="onSort($event)"
      [hideCheckboxes]="true"
      [showActionButton]="false"
      [getMenuActions]="getMenuActions.bind(this)"
      (menuActionTriggered)="menuActionTriggered($event)"
    ></app-table>
  </div>


</div>
